import { $ } from './modules/dom.ts';

const branchName = (pathname: string) => {
  if (pathname.startsWith('/')) pathname = pathname.substring(1);
  if (pathname.endsWith('/')) pathname = pathname.substring(0, pathname.length - 1);
  return pathname;
};
if ($('#branch-name')) {
  ($('#branch-name') as HTMLElement).innerText = branchName(window.location.pathname);
}

// Create the event
const reflowPlease = new CustomEvent('reflowPlease');

const instructions = $('#instructions') as HTMLElement;
const hidden = $('#hidden') as HTMLElement;

// The collapsed state is sticky per page (sessionStorage, so per tab) because
// a teacher reviewing student work reloads the page for each student and
// shouldn't have to re-collapse the instructions every time. Storage may be
// absent or throw (private windows, blocked site data); the toggle still works
// without it.
const collapsedKey = `instructions-collapsed:${window.location.pathname}`;

const rememberCollapsed = (collapsed: boolean) => {
  try {
    if (collapsed) {
      sessionStorage.setItem(collapsedKey, '1');
    } else {
      sessionStorage.removeItem(collapsedKey);
    }
  } catch {
    // No storage: the state just isn't sticky.
  }
};

const wasCollapsed = () => {
  try {
    return sessionStorage.getItem(collapsedKey) === '1';
  } catch {
    return false;
  }
};

const hideInstructions = () => {
  hidden.style.display = 'block';
  instructions.style.display = 'none';
};

const showInstructions = () => {
  hidden.style.display = 'none';
  instructions.style.display = 'block';

  // Kludge to tell Monaco to lay itself out again since for some reason it
  // doesn't otherwise. (It does fine when we hide the instructions and it gets
  // more space but when we reveal the instructions it doesn't shrink back
  // down.)
  window.dispatchEvent(reflowPlease);
};

if ($('#close')) {
  const close = $('#close') as HTMLElement;
  const sibling = close.nextElementSibling;
  if (sibling) {
    close.onclick = () => {
      hideInstructions();
      rememberCollapsed(true);
    };
    // Tuck the collapse caret inside the first instructions element.
    sibling.prepend(close);
    if (wasCollapsed()) hideInstructions();
  } else {
    // Empty instructions block (e.g. a quiz with no instructions): there's
    // nothing to collapse, so hide the block and its (already-hidden) toggle
    // rather than leaving a lone caret — or throwing on the missing sibling.
    instructions.style.display = 'none';
  }
}
if ($('#open')) {
  ($('#open') as HTMLElement).onclick = () => {
    showInstructions();
    rememberCollapsed(false);
  };
}
